import {parseISO, compareAsc, format, addMinutes} from 'date-fns';
import * as byteSize from '../../../bytesize';
import {FILTER_DESCRIPTIONS} from '../../../constants';

function buildSeries(data, keyToDescription) {
  let series = [];
  if (Array.isArray(data) && data.length > 0) {
    data.forEach(item => {
       if (item && item.value > 0) {
         if (keyToDescription) {
           series.push({name: keyToDescription[item.name], y: item.value, drilldown: item.name});
         } else{
           series.push({name: item.name, y: item.value, drilldown: item.name});
         }
       }
    });
  }
  return series;
}

export default {
  deviceCountByFormFactorSeries: state => {
    let series = [];
    if (state.chartData && state.chartData.deviceCountByFormFactor) {
      const formFactorData = state.chartData.deviceCountByFormFactor.data;
      series = buildSeries(formFactorData, null);
    }
    return series;
  },

  deviceCountByModelSeries: state => {
    let series = [];
    if (state.chartData && state.chartData.deviceCountByModel) {
      const deviceCountModelData = state.chartData.deviceCountByModel.data;
      series = buildSeries(deviceCountModelData, null);
    }
    return series;
  },

  deviceCountByWarrantyExpirationSeries: state => {
    let series = [];

    if (state.chartData && state.chartData.deviceCountByWarrantyExpiration) {
      const warrantyData = state.chartData.deviceCountByWarrantyExpiration.data;
      series = buildSeries(warrantyData, FILTER_DESCRIPTIONS['warranty']);
    }
    return series;
  },

  devicesByAgeSeries: state => {
    let series = [];

    if (state.chartData && state.chartData.devicesByAge) {
      const ageData =  state.chartData.devicesByAge.data;
      series = buildSeries(ageData, FILTER_DESCRIPTIONS['age']);
    }
    return series;
  },

  devicesByUtilisationSeries: state => {
    let series = [];

    if (state.chartData && state.chartData.devicesByUtilisation) {
      const utilisationData = state.chartData.devicesByUtilisation.data;
      series  = buildSeries(utilisationData, FILTER_DESCRIPTIONS['utilisation']);
    }
    return series;
  },

  deviceFormFactorSelectData: state => {
    let selectData = [];
    if (state.chartData && state.chartData.deviceCountByFormFactor) {
      const formFactorData = state.chartData.deviceCountByFormFactor.data;
      if (Array.isArray(formFactorData) && formFactorData.length > 0) {
        formFactorData.forEach(item => {
          if (item && item.value > 0) {
            selectData.push({label: item.name, value: item.name});
          }
        });
      }
    }
    return selectData;
  },

  deviceAgeSelectData: state => {
    let selectData = [];
    if (state.chartData && state.chartData.devicesByAge) {
      const ageData = state.chartData.devicesByAge.data;
      if (Array.isArray(ageData) && ageData.length > 0) {
        ageData.forEach(item => {
          if (item && item.value > 0) {
            selectData.push({label: FILTER_DESCRIPTIONS['age'][item.name], value: item.name});
          }
        });
      }
    }
    return selectData;
  },

  deviceUtilisationSelectData: state => {
    let selectData = [];
    if (state.chartData && state.chartData.devicesByUtilisation) {
      const utilisationData = state.chartData.devicesByUtilisation.data;
      if (Array.isArray(utilisationData) && utilisationData.length > 0) {
        utilisationData.forEach(item => {
          if (item && item.value > 0) {
            selectData.push({label: FILTER_DESCRIPTIONS['utilisation'][item.name], value: item.name});
          }
        });
      }
    }
    return selectData;
  },

  deviceWarrantySelectData: state => {
    let selectData = [];
    if (state.chartData && state.chartData.deviceCountByWarrantyExpiration) {
      const warrantyData = state.chartData.deviceCountByWarrantyExpiration.data;
      if (Array.isArray(warrantyData) && warrantyData.length > 0) {
        warrantyData.forEach(item => {
          if (item && item.value > 0) {
            selectData.push({label: FILTER_DESCRIPTIONS['warranty'][item.name], value: item.name});
          }
        });
      }
    }
    return selectData;
  },

  deviceBuildNumberSelectData: state => {
    let selectData = [];
    if (state.chartData && state.chartData.deviceBuildNumber) {
      const data = state.chartData.deviceBuildNumber.data;
      if (Array.isArray(data) && data.length > 0) {
        data.forEach(item => {
          if (item && item.value > 0) {
            selectData.push({label: item.name, value: item.name});
          }
        });
      }
    }
    return selectData;
  },

  deviceOperatingSystemSelectData: state => {
    let selectData = [];
    if (state.chartData && state.chartData.deviceOperatingSystem) {
      const data = state.chartData.deviceOperatingSystem.data;
      if (Array.isArray(data) && data.length > 0) {
        data.forEach(item => {
          if (item && item.value > 0) {
            selectData.push({label: item.name, value: item.name});
          }
        });
      }
    }
    return selectData;
  },

  deviceModelSelectData: state => {
    let selectData = [];
    if (state.chartData && state.chartData.deviceCountByModel) {
      const data = state.chartData.deviceCountByModel.data;
      if (Array.isArray(data) && data.length > 0) {
        data.forEach(item => {
          if (item && item.value > 0) {
            selectData.push({label: item.name, value: item.name});
          }
        });
      }
    }
    return selectData;
  },

  devices: state => {
    const dataNotAvailable = 'Data not available';

    const formatDate = (str) => {
      if (str) {
        if (str === '0') {
          return 'Data not available';
        }
        const utc = parseISO(str);
        const offset = new Date().getTimezoneOffset();
        return format(addMinutes(utc, offset), 'dd/MM/yyyy');
      }
      return 'Data not available';
    };

    const isWindowsDevice = (operatingSystem) => {
      if (operatingSystem) {
        const operationSystem = operatingSystem.toLowerCase();
        if (operationSystem.indexOf('windows') > -1) {
          return true;
        }
      }
      return false;
    };

    const getOnOfflineTime = (operatingSystem, onOfflineTime) => {
      if (onOfflineTime) {
        return formatDate(onOfflineTime);
      } else {
        if (isWindowsDevice(operatingSystem)) {
          return 'Over 180 days ago';
        } else {
          return 'Data not available';
        }
      }
    };

    const getMemorySize = (deviceMemory) => {
      if (deviceMemory > 0) {
        // return byteSize(deviceMemory * Math.pow(1000, 2)).toString();
        return (deviceMemory * 0.001).toPrecision(2) + ' GB';
      } else {
        return 'Data not available';
      }
    };

    const getHddSize = (localDisk) => {
      if (localDisk > 0) {
        // return byteSize(localDisk * Math.pow(1000, 3)).toString();
        return `${localDisk} GB`;
      } else {
        return 'Data not available';
      }
    };

    let deviceData = [];
    if (state.devices && state.devices.data) {
      if(Array.isArray(state.devices.data) && state.devices.data.length > 0 ) {
        deviceData = state.devices.data.map( (source) => {
          const filteredData = {};
          filteredData.device_name = source.device_name ? source.device_name : dataNotAvailable;
          filteredData.location = source.location ? source.location : dataNotAvailable;
          filteredData.model = source.model ? source.model : dataNotAvailable;
          filteredData.serialnumber = source.serialnumber ? source.serialnumber : dataNotAvailable;
          filteredData.os_service_pack = source.os_service_pack ? source.os_service_pack : dataNotAvailable;
          filteredData.operating_system = source.operating_system? source.operating_system: dataNotAvailable;
          filteredData.release_year = formatDate(source.release_year);
          filteredData.warranty = formatDate(source.warranty);
          filteredData.cnlastonlinetime = getOnOfflineTime(source.operating_system, source.cnlastonlinetime);
          filteredData.cnlastofflinetime = getOnOfflineTime(source.operating_system, source.cnlastofflinetime);
          filteredData.device_specification = source.device_specification ? source.device_specification: dataNotAvailable;
          filteredData.hdd_size_gb = getHddSize(source.hdd_size_gb);
          filteredData.total_memory_mb = getMemorySize(source.total_memory_mb);
          filteredData.manufacturer = source.manufacturer ? source.manufacturer : dataNotAvailable;
          filteredData.form_factor = source.form_factor ? source.form_factor : dataNotAvailable;
          filteredData.sitecode = source.sitecode ? source.sitecode : dataNotAvailable;
          filteredData.last_logon_user = source.last_logon_user ? source.last_logon_user : dataNotAvailable;

          return filteredData;
        });
      }
    }
    return deviceData;
  },

  deviceCount: state => {
    return state.deviceCount.data ? state.deviceCount.data.count : null;
  },

  devicePagination: state => {
    return state.devices.pagination;
  },

  devicesPerStudent: (state, getters, rootState) => {
    const count = getters.deviceCount;
    const students = rootState.school.selected.site_enrolments;
    const ratio = students / count;
    if (isNaN(ratio)) {
      return null;
    }
    return (count / students).toFixed(2);
  },

  authToken: (state, getters, rootState) => {
    if (rootState.auth) {
      return rootState.auth.token
    }
    return "";
  },

  deviceBuildNumberCountSeries: state => {
    let series = [];
    if (state.chartData && state.chartData.deviceBuildNumber) {
      const deviceBuildBumberData = state.chartData.deviceBuildNumber.data;
      series = buildSeries(deviceBuildBumberData, null);
    }
    return series;
  },

  deviceOperatingSystemSeries: state => {
    let series = [];
    if (state.chartData && state.chartData.deviceOperatingSystem) {
      const deviceOperatingSystemData = state.chartData.deviceOperatingSystem.data;
      series = buildSeries(deviceOperatingSystemData, null);
    }
    return series;
  },

  /// Internet Usage dashboard
  /**
   * Calculate and return the HourlyBandwidthUsage Department data series.
   *
   * NOTE: Highcharts throws Error #15 if you do not sort your data by x ascending, so it is our responsibility.
   *
   * @param state
   * @returns {Array}
   */
  hourlyBandwidthUsageByDepartmentSeries: (state) => {
    let series = [];
    if (Array.isArray(state.chartData.hourlyBandwidthUsage.department) && state.chartData.hourlyBandwidthUsage.department.length > 0) {
      series = state.chartData.hourlyBandwidthUsage.department.map(wud => {
        return {x: parseISO(wud.name), y: wud.value}
      }).sort((a, b) => compareAsc(a.x, b.x));
      return series;
    } else {
      return series;
    }
  },

  /**
   * Calculate and return the HourlyBandwidthUsage nonDepartment data series.
   *
   * NOTE: Highcharts throws Error #15 if you do not sort your data by x ascending, so it is our responsibility.
   *
   * @param state
   * @returns {Array}
   */
  hourlyBandwidthUsageByNonDepartmentSeries: (state) => {
    let series = [];
    if (Array.isArray(state.chartData.hourlyBandwidthUsage.nonDepartment) && state.chartData.hourlyBandwidthUsage.nonDepartment.length > 0) {
      series = state.chartData.hourlyBandwidthUsage.nonDepartment.map(wud => {
        return {x: parseISO(wud.name), y: wud.value}
      }).sort((a, b) => compareAsc(a.x, b.x));
      return series;
    } else {
      return series;
    }
  },

  numberOfHitsSeries: state => {
    if (state.chartData.numberOfHits.data.length === 0) {
      return null;
    }
    let series = [];

    if (state.chartData.numberOfHits.data) {
      series = state.chartData.numberOfHits.data.map(ffd => {
        if (ffd.value === 0) {
          return null;
        } // Dont include zero totals

        if (ffd.isDepartment) {
          return {name: ffd.name, y: ffd.value, isDepartment: ffd.isDepartment, color: '#1D428A'};
        } else {
          return {name: ffd.name, y: ffd.value, isDepartment: ffd.isDepartment, color: '#6BACE4'};
        }
      });
    }

    return series;
  },

  bandwidthUsageSeries: state => {
    if (state.chartData.bandwidthUsage.data.length === 0) {
      return null;
    }
    let series = [];

    if (state.chartData.bandwidthUsage.data) {
      series = state.chartData.bandwidthUsage.data.map(ffd => {
        if (ffd.value === 0) {
          return null;
        } // Dont include zero totals

        if (ffd.isDepartment) {
          return {name: ffd.name, y: ffd.value, isDepartment: ffd.isDepartment, color: '#1D428A'};
        } else {
          return {name: ffd.name, y: ffd.value, isDepartment: ffd.isDepartment, color: '#6BACE4'};
        }
      });
    }

    return series;
  },

  deviceFormFactorFilter: (state) => {
    return state.filters.formfactor;
  },

  deviceAgeFilter: (state) => {
    return state.filters.age;
  },

  deviceUtilisationFilter: (state) => {
    return state.filters.utilisation;
  },

  deviceWarrantyFilter: (state) => {
    return state.filters.warranty;
  },

  deviceBuildNumberFilter: (state) => {
    return state.filters.buildNumber;
  },

  deviceOperatingSystemFilter: (state) => {
    return state.filters.operatingSystem;
  },

  deviceModelFilter: (state) => {
    return state.filters.model;
  },

}
